import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class TokenResolver  {
  constructor(
    private authservice: AuthService,
    private router: Router,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<any> {
    return this.authservice.getAccessTokenSilently().pipe(
      tap(token => {
        if (token) {
          localStorage.setItem('token', token);
        } else {
          this.authservice.logout({ returnTo: window.location.origin });
        }
      }),
      catchError((error) => {
        console.error('TokenResolver: Error al obtener token silenciosamente, redirigiendo a login:', error);
        this.authservice.logout({ returnTo: window.location.origin });
        return of(null);
      })
    );
  }
}
